import { startLoading, stopLoading } from "../common/utils/button-loading";
import { BaseResponse } from "../common/interfaces/responses";
import { deleteComment } from "./services/comment-service";
import Tribute from "tributejs";

declare var pm: PmInterface;

export default function setupComment() {
	const { findFormEl, getClosest } = pm.utils.dom;

	let tributeInstance: Tribute<any> | null = null;

	// ! Couldn't get tribute.append to work, so yea.. let's load them all.
	let limit = 1000000;
	let currentPage = 1;
	let offset = 0;

	let totalLoaded = 0;

	let isProcessing = false;

	init();

	function init() {
		document.addEventListener("click", handleDocumentClick);
		document.addEventListener("keydown", handleDocumentKeydown);
		// setupMention();

		const commentForm = findFormEl("#commentform");

		if (commentForm) {
			setupCommentForm(commentForm);
		}
	}

	async function handleDocumentClick(e: MouseEvent) {
		const target = e.target as HTMLElement;
		const button = getClosest(target, ".delete-comment", 10) as HTMLElement;
		if (!button) return;

		let commentId = button.dataset.commentId;
		if (!commentId) return;

		await removeComment(parseInt(commentId, 10), button);
	}

	function handleDocumentKeydown(e: KeyboardEvent) {
		const target = e.target as HTMLElement | HTMLTextAreaElement | null;
		if (!target) return;
		if (target.tagName.toLowerCase() !== "textarea") return;
		if (!target.classList.contains("comment-form-textarea")) return;

		const commentForm = getClosest(
			target,
			".comment-form",
			5,
		) as HTMLElement | null;
		if (!commentForm) return;

		const value = (target as HTMLTextAreaElement).value.trim();

		if (value) {
			const errorNotice = commentForm.querySelector(
				".comment-form-error-message",
			);

			if (errorNotice) {
				errorNotice.innerHTML = "";
				errorNotice.classList.add("is-hidden");
			}
		}
	}

	async function removeComment(commentId: number, button: HTMLElement) {
		if (isProcessing) return;
		if (!confirm("Are you sure you want to delete this comment?")) return;

		const wrapper = document.querySelector(
			"#comment-" + button.dataset.commentId,
		) as HTMLElement | null;
		if (!wrapper) return;

		const commentListWrapper = getClosest(wrapper, ".commentlist", 25);
		if (!commentListWrapper) return;

		isProcessing = true;
		startLoading(button);

		const response: BaseResponse = await deleteComment(commentId);

		if (response.success) {
			setTimeout(function () {
				const commentsCount = commentListWrapper.querySelector(
					"#comments-title span",
				) as HTMLElement | null;

				wrapper!.parentNode!.removeChild(wrapper!);

				if (commentsCount) {
					const totalComments: number = commentListWrapper.querySelectorAll(
						".comments li[data-comment-id]",
					).length;

					commentsCount.textContent = totalComments.toString();
					const commentsTitle = commentsCount.parentNode as HTMLElement;

					if (!totalComments) {
						commentsTitle.classList.add("is-hidden");
					} else {
						commentsTitle.classList.remove("is-hidden");
					}
				}
			}, 150);
		}

		isProcessing = false;
		stopLoading(button);
	}

	function setupMention() {
		// Create new tribute instance.
		tributeInstance = new Tribute({
			lookup: function (user, mentionText) {
				return user.user_nicename + " - " + user.display_name;
			},
			selectTemplate: function (item) {
				return "@" + item.original.user_nicename;
			},
			values: <
				{
					ID: number;
					user_nicename: string;
					display_name: string;
				}[]
			>[],
		});

		// getTributeValues();
	}

	function getTributeValues() {
		jQuery
			.ajax({
				url: pm.ajaxurl,
				type: "POST",
				data: {
					action: "pm_get_tribute_values",
					nonce: pm.nonces.getTributeValues,
					limit: limit,
					offset: offset,
				},
			})
			.done(function (r) {
				if (!r.success) return;
				if (r.data.length < 1) return;

				if (totalLoaded > 0) {
					// Append values to our tribute instance.
					tributeInstance?.append(totalLoaded - 1, r.data);
				} else {
					// Append values to our tribute instance.
					tributeInstance?.append(0, r.data);
				}

				currentPage++;
				offset += limit;
				totalLoaded += r.data.length;

				getTributeValues();
			})
			.fail(function (jqXHR) {
				console.log(buildErrorMsg(jqXHR));
			});
	}

	function setupCommentForm(form: HTMLFormElement) {
		const field = form.querySelector(".comment-form-textarea");

		if (field instanceof HTMLTextAreaElement) {
			tributeInstance?.attach(field);
		}

		form.addEventListener("submit", onCommentFormSubmit);
	}

	function onCommentFormSubmit(this: HTMLFormElement, e: Event) {
		const commentField = this.querySelector(".comment-form-textarea");
		if (!(commentField instanceof HTMLTextAreaElement)) return;
		const value = commentField.value.trim();

		const errorNotice = this.querySelector(".comment-form-error-message");
		if (!(errorNotice instanceof HTMLElement)) return;

		if (!value) {
			e.preventDefault();

			errorNotice.innerHTML = "Please enter a comment.";
			errorNotice.classList.remove("is-hidden");
		}
	}

	function buildErrorMsg(jqXHR: JQuery.jqXHR<any>) {
		var errorMsg =
			jqXHR.responseJSON && jqXHR.responseJSON.data
				? jqXHR.responseJSON.data
				: "Something went wrong";

		return errorMsg;
	}
}
